import React from 'react'
import { Paginator } from '@deseretbook/react-ui'
import { connectPagination } from 'react-instantsearch-dom'
import PropTypes from 'prop-types'

/**
 * Pagination component for Algolia
 *
 * @see https://www.algolia.com/doc/api-reference/widgets/pagination/react/
 *
 * @param {string} params.currentRefinement - Current Page
 * @param {boolean} params.nbPages - Total number of pages for results
 * @param {function} params.refine - Changes the current page
 *
 * @returns {function} React component
 */
const PaginationComponent = ({ currentRefinement, nbPages, refine }) => {
  /**
   * Updates the current page
   *
   * @param {number} newPage - The page to go to
   */
  const handlePageChange = (newPage) => {
    // Scroll back to top of search container
    document.getElementById('algolia-container').scrollTop = 0

    refine(newPage)
  }

  return (
    <Paginator
      currentPage={currentRefinement}
      totalPages={nbPages}
      setCurrentPage={handlePageChange}
    />
  )
}

PaginationComponent.propTypes = {
  currentRefinement: PropTypes.number,
  nbPages: PropTypes.number,
  refine: PropTypes.func,
}

export const Pagination = connectPagination(PaginationComponent)
